import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get, } from "lodash";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import "./usermanagement.css";
import Input from "../../components/Input";
import Overlay from "../../components/Overlay";
import { Modal } from "../../components/Modal";
import { bottom } from "@popperjs/core";
import { extractDate, extractOnlyDate, maskToken, uploadImage, subadminAccessChange } from "../../utils/functions";
import * as XLSX from 'sheetjs-style';
import { saveAs } from "file-saver";

// Mui & material UI
import Stack from '@mui/material/Stack';
import SearchBar from "material-ui-search-bar";
import {
  TextField,
  Popover,
  Box,
  FormControl,
  FormGroup,
  FormControlLabel,
  Divider,
  Typography
} from "@mui/material";


import Pagination from '@mui/material/Pagination';
import { makeStyles } from "@material-ui/core/styles";
import PaginationItem from '@mui/material/PaginationItem';
import {
  Paper,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination
} from "@material-ui/core";

// icons 
import { HiOutlineBars3BottomLeft } from "react-icons/hi2";
import { AiOutlineDownload } from "react-icons/ai";
import { GrApple } from "react-icons/gr";
import { PiAndroidLogoFill, PiWifiMediumThin } from "react-icons/pi";
import { RxCross2, RxCrossCircled } from "react-icons/rx";
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";
import { TiInfoLarge } from "react-icons/ti";
import { AiOutlineMail } from "react-icons/ai";
import { IoCallOutline } from "react-icons/io5";
import { GoCalendar } from "react-icons/go";
import { LuContact } from "react-icons/lu";


// import Vector from "../../assets/images/Vector.png";
import Verified from "../../assets/images/verification.png";
import vector from "../../assets/images/Vector.png";



// Elements
import {
  DashboardContainer,
  DashboardWrapper,
  DashboardHeading,
  SearchFilterContainer,
  DashHeading,
  Button,
  DeleteButton,
  ProfileDetailForm,
  SelectedColumnContainer,
} from "./UserManagementElements";

import android from "../../assets/images/Androide.png";
import NoResults from "../../components/NoResult";
import Loading from "../../components/Loading";


const useStyles = makeStyles((theme) => ({
  table: {
    borderCollapse: 'separate',
    borderSpacing: '0 6px', // adds vertical spacing between rows
  },
  tableMainContainer: {
    maxHeight: "65vh",
    overflowX: "auto",
    overflowY: "auto",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
  },
  tableHeadingRow: {
    position: "sticky", // Make header sticky
    top: 0, // Stick to the top
    zIndex: 1, // Ensure it appears above other rows
    background: "#FFFFFF", // Header background color
    // border: "1px solid rgba(17, 153, 38, 0.20)",

  },
  tableBodyRow: {
    background: "#FFFFFF",


    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  tableHeadingCell: {
    // padding: "0.5rem 1rem !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#1C2D28",
    fontWeight: "500",
    // border: "1px solid #D9E3D9",
    whiteSpace: "nowrap",
    background: "#FFFFFF",
    border: "none"
  },
  textMiddle: {
    // padding: "0.4rem 1rem !important",
    verticalAlign: "middle !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#484848",
    fontFamily: "Roboto",
    fontWeight: "400",
    background: "#FFFFFF",
    border: "none"
  },
  tablePaginationStyle: {
    borderTop: "1px solid #0000001a",
    borderRadius: "0rem 0rem 0.4rem 0.4rem",
    overflowY: "hidden",
  },
  paginationContainer: {
    marginTop: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));

const RegistrationRequest = ({ setUsers, userData }) => {
  const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

  const userManagementPermissions = adminData?.adminpermissions?.modules?.find(
    (module) => module.moduleName === "User Management"
  )?.permissions || {};

  const canView = !!userManagementPermissions.view;
  const canAdd = !!userManagementPermissions.add;
  const canEdit = !!userManagementPermissions.edit;
  const canDelete = !!userManagementPermissions.delete;
  const canBlockUnblock = !!userManagementPermissions.blockUnblock;
  const canDownload = !!userManagementPermissions.download;



  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [showClearFilter, setShowClearFilter] = useState(false);

  const [userDetails, setUserDetails] = useState()
  const [deleteModal, setDeleteModal] = useState(false);

  const [filterStatus, setFilterStatus] = useState(
    localStorage.getItem("filterTypeVerification") || 1
  ); // Default to active users

  const handleServiceTypeChange = (type) => {
    setFilterStatus(type);
    setIsLoading(true)
    localStorage.setItem("filterTypeVerification", type); // Save the active tab to localStorage (filterTypeVerification)
  };



  const [orderByFilterStatus, setOrderByFilterStatus] = useState();
  const [sortByFilterStatus, setSortByFilterStatus] = useState();
  const [values, setValues] = useState({
    stripe: false,
    admin: false,
    incomplete: false,
  });

  const [tempValues, setTempValues] = useState({
    stripe: false,
    admin: false,
    incomplete: false,
    rejectedStripe: false,
    rejectedAdmin: false,
  });
  const [appliedFilters, setAppliedFilters] = useState({});
  const [rejectStatusFilter, setRejectStatusFilter] = useState([]);
  const [filterError, setFilterError] = useState(false);

  const [sorting, setSorting] = useState({
    sortByUserName: null,
    sortByJoiningDate: null,
    sortByRecentActivityDate: null,
    sortByRejectingDate: null,
    sortByUserId: null,
    defaultSorting: -1
  });
  const [rotations, setRotations] = useState({
    sortByUserName: 0,
    sortByJoiningDate: 0,
    sortByRecentActivityDate: 0,
    sortByRejectingDate: 0,
    sortByUserId: 0,

  });





  // const [rotated, setRotated] = useState(false);

  // const handleImageClick = () => {
  //   setRotated(!rotated);
  // };


  // For Pagination
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalDocs, setTotalDocs] = useState(0);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(1); // Reset to the first page when rows per page change
  };

  const handleChangePage = (event, newPage) => {
    // handleCancel();
    setPage(newPage);

    // Check if navigating from registrationRequest page and store the page

    localStorage.setItem("currentPage", newPage); // Store the page number

  };


  const handleChange = (e) => {
    setTempValues((prev) => ({
      ...prev,
      [e.target.name]: e.target.checked,
    }));
  };


  const handleApplyFilter = () => {
    const selectedStatuses = [];

    if (tempValues.stripe) selectedStatuses.push(1);
    if (tempValues.admin) selectedStatuses.push(2);
    if (tempValues.incomplete) selectedStatuses.push(0);
    if (tempValues.rejectedStripe) selectedStatuses.push(3);
    if (tempValues.rejectedAdmin) selectedStatuses.push(4);

    // Show error if no checkbox is selected
    if (selectedStatuses.length === 0) {
      toast.error("Please select at least one filter.");
      return;
    }

    //  Clear error if valid and proceed
    setFilterError("");
    setValues(tempValues);
    setAppliedFilters({ ...tempValues });
    setRejectStatusFilter(selectedStatuses);
    handleCloseFilter();
    setShowClearFilter(true);
    setPage(1)
  };



  const handleClearAllFilters = () => {
    const resetValues = {
      stripe: false,
      admin: false,
      incomplete: false,
      rejectedStripe: false,
      rejectedAdmin: false,

    };
    setShowClearFilter(false);
    setTempValues(resetValues);
    setValues(resetValues); // if you're storing final applied values too
    setRejectStatusFilter([]); // reset filtering
    handleCloseFilter();
    setAppliedFilters(resetValues);
  };





  // For Select checkbox
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (tableData.length === 0) {
      setSelectedRows([]);
    }
  }, [tableData]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedRows(tableData.map((item) => item._id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleSelectRow = (id) => {
    const newSelectedRows = selectedRows.includes(id)
      ? selectedRows.filter((rowId) => rowId !== id)
      : [...selectedRows, id];
    setSelectedRows(newSelectedRows);
  };





  const handleClearSelection = () => {
    setSelectedRows([]);
  };


  // Filter Start
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null); // For device type filtering
  const [filterDates, setFilterDates] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElFilter, setAnchorElFilter] = useState(null);




  const handleCancel = () => {
    setSelectedOption(null);
    handleCloseFilter();
    setPage(1);
    setFilterError(false)
  };

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget); // Open the filter popover
  };

  const handleClose = () => {
    setAnchorEl(null); // Only close the popover without resetting
  };

  const open = Boolean(anchorEl);
  const id = open ? "filter-popover" : undefined;


  const FilterClick = (event) => {
    setAnchorElFilter(event.currentTarget); // Open the filter popover
  };

  const handleCloseFilter = () => {
    setAnchorElFilter(null); // Only close the popover without resetting
  };

  const openFilter = Boolean(anchorElFilter);
  const ids = openFilter ? "filter-popover" : undefined;




  // For Search functionality
  const [searchTerm, setSearchTerm] = useState("");

  function myDeb(call, d = 1000) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        call(...args);
      }, d);
    };
  }

  const SearchAccountManagement = myDeb((search) => {
    setSelectedRows([]);
    setSearchTerm(search);
    setPage(1); // Reset to the first page on search
  });

  const cancelSearch = () => {
    setSearchTerm("");
    setPage(1); // Reset to the first page when search is canceled
  };


  // Get user data
  useEffect(() => {

    getAllUserListData(page)
    getExcelData()
      .then((res) => res.json())
      .then((data) => setExcelData(data))
      .catch((error) => console.error("Error fetching data:", error));

  }, [page, rowsPerPage, searchTerm, filterStatus, filterDates, rejectStatusFilter]);



  const toggleSort = (field) => {
    setSorting((prev) => {
      let newSorting = {
        sortByUserName: null,
        sortByJoiningDate: null,
        sortByRecentActivityDate: null,
        sortByRejectingDate: null,
        sortByUserId: null,
        defaultSorting: null,
      };

      let newValue = prev[field] === 1 ? -1 : 1;
      newSorting[field] = newValue;

      // 👉 Rotate image toggle
      setRotations((prev) => ({
        ...prev,
        [field]: prev[field] === 0 ? 180 : 0, // toggle between 0 and 180
      }));

      // API call
      getAllUserListData(1, newSorting);

      return newSorting;
    });
  };




  const getAllUserListData = async (currentPage, sortingParam = sorting) => {
    setIsLoading(true);
    setTotalDocs(0);

    try {
      const { data } = await axios.post(`/private/getAllUserList?page=${currentPage}&limit=${rowsPerPage}&search=${searchTerm}`, {

        status: String(filterStatus),
        rejectStatus: rejectStatusFilter.map(String),
        // sortByReject: "1",
        ...sortingParam,
      });
      console.log("gwfwefjwehgfejw", data)

      setTableData(data?.data?.docs);
      setTotalDocs(data?.data?.totalDocs);

    } catch (error) {
      if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
        navigate("/");
      } else if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else {
        console.log("error", error?.response)
      }
    } finally {
      setIsLoading(false);
    }
  };


  // Delete user functionality - handles both single and multiple deletions
  const DeleteUser = async (id = null) => {
    const idsToDelete = id ? [id] : selectedRows;

    if (idsToDelete.length === 0) {
      toast.error('No users selected for deletion', {
        position: "top-right",
      });
      return;
    }

    setIsLoading(true);

    try {
      // Using axios.request to support sending data in the body with DELETE method
      const { data } = await axios({
        method: 'delete',
        url: `/private/deleteUsers`,
        data: {
          ids: idsToDelete,
        },
      });

      setDeleteModal(false);
      toast.success(data?.message);
      handleClearSelection();
      setSelectedRows([]);  // Clear selected rows after deletion
      getAllUserListData(page);  // Refresh table after deletion
    } catch (error) {
      if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        toast.error('Something went wrong', {
          position: "top-right",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };




  const handleDownload = () => {
    // Format keys: convert camelCase to space-separated & capitalize, handle _id
    const formatKey = (key) => {
      if (key === '_id') return 'User Id';
      return key
        .replace(/([a-z])([A-Z])/g, '$1 $2')  // Add space before capital letters
        .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
    };

    // Function to format date if key is createdAt
    const formatValue = (key, value) => {
      if ((key === "createdAt" || key === "requestRejectOn") && value) {
        return new Date(value).toLocaleString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
          hour12: true
        });
      }
      return value;
    };


    // Format data with formatted headers
    const formattedData = excelData.map(item => {
      const newItem = {};
      Object.entries(item).forEach(([key, value]) => {
        newItem[formatKey(key)] = formatValue(key, value);
      });
      return newItem;
    });

    // Create worksheet from formatted data
    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    // Auto-calculate column widths
    const keys = Object.keys(formattedData[0] || {});
    const colWidths = keys.map(key => {
      const maxLength = Math.max(
        key.length,
        ...formattedData.map(row => (row[key] ? row[key].toString().length : 0))
      );
      return { wch: maxLength + 2 };
    });
    worksheet["!cols"] = colWidths;

    // Bold header row (row 0)
    keys.forEach((key, index) => {
      const cellAddress = XLSX.utils.encode_cell({ c: index, r: 0 });
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].s = {
          font: { bold: true }
        };
      }
    });

    // Create workbook and append sheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Write and download
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "table_data.xlsx");
  };


  // getExcelData
  const getExcelData = async () => {

    try {
      const { data } = await axios.post(`/private/getUserExcelData`, {

        status: String(filterStatus),

      });
      setExcelData(data?.data);


    } catch (error) {
      if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");

      } else {
        console.log("error", error?.response)
      }
    } finally {
      setIsLoading(false);
    }
  };


  const [expandedRows, setExpandedRows] = useState({});

  const toggleExpand = (id, field) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: {
        ...(prev[id] || {}), // Preserve existing expanded fields for the row
        [field]: !prev[id]?.[field], // Toggle only the clicked field
      },
    }));
  };

  useEffect(() => {
    if (location.state?.page) {
      setPage(location.state.page);
    }
    if (location.state?.rowsPerPage) {
      setRowsPerPage(location.state.rowsPerPage);
    }
  }, []);


  return (
    <>
      <DashboardContainer>
        <DashboardWrapper>
          <ProfileDetailForm>
            <DashboardHeading style={{ display: "flex", justifyContent: "space-between", cursor: "pointer" }}>

              <div>Registration Requests</div>
              {!(!canDownload && adminData?.userType === "subAdmin") && (
                <Button
                  type="button"
                  style={{ backgroundColor: "#5088FB", color: "#FFFFFF", border: "1px solid #5088FB", fontFamily: "Inter", fontSize: "14px", fontWeight: "400", padding: "4px 8px" }}
                  onClick={handleDownload}
                >
                  Export as xlsx <AiOutlineDownload style={{ fontSize: "1.2rem" }} />
                </Button>
              )}

            </DashboardHeading>


            <SearchFilterContainer>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                <div style={{ display: "flex", gap: "1rem" }}>
                  <Button
                    type="button"
                    style={{
                      backgroundColor:
                        filterStatus == 1 ? "#5088FB" : "",
                      color: filterStatus == 1 ? "#ffffff" : "#201D23",
                      fontSize: "14px",
                      fontFamily: "Inter",
                      fontWeight: filterStatus == 1 ? "600" : "400",
                    }}
                    onClick={() => {
                      handleCancel();
                      setSelectedRows([]);
                      handleServiceTypeChange(1)
                      setPage(1);
                      setSearchTerm("");
                      handleClearAllFilters()
                    }}
                    disabled={filterStatus == 1}
                  >
                    Pending Requests {filterStatus == 1 ? `(${isLoading ? "" : totalDocs})` : ""}
                  </Button>
                  <Button
                    type="button"
                    style={{
                      backgroundColor:
                        filterStatus == 3 ? "#5088FB" : "",
                      color: filterStatus == 3 ? "#ffffff" : "#201D23",
                      fontSize: "14px",
                      fontFamily: "Inter",
                      fontWeight: filterStatus == 3 ? "600" : "400",
                    }}
                    onClick={() => {
                      handleCancel();
                      setSelectedRows([]);
                      handleServiceTypeChange(3)
                      setPage(1);
                      setSearchTerm("");
                      handleClearAllFilters()
                    }}
                    disabled={filterStatus == 3}
                  >
                    Rejected Requests {filterStatus == 3 ? `(${isLoading ? "" : totalDocs})` : ""}
                  </Button>
                </div>
                <div style={{ display: "flex", gap: "1rem", alignItems: "center", }}>
                  <div >
                    <SearchBar
                      style={{
                        minWidth: "23rem",
                        height: "38px",
                        borderRadius: "20px",
                        backgroundColor: "#F8F9FB",
                        color: "#212121",
                        fontStyle: "Italic",
                        fontWeight: 300,
                        fontSize: "15px",
                        fontFamily: "Roboto",
                      }}
                      className={"heightfix"}
                      onChange={(e) => {
                        SearchAccountManagement(e);
                      }}
                      value={searchTerm}
                      onCancelSearch={cancelSearch}
                      placeholder="Search by user id, user name"
                      inputProps={{ maxLength: 30 }}
                    />
                  </div>
                </div>
                <div style={{ display: "flex", gap: "1rem", alignItems: "center", }}>
                  <div>
                    {showClearFilter && (
                      <div variant="outlined" onClick={handleClearAllFilters} style={{ color: "red", fontSize: "14px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                        <RxCross2 style={{ fontSize: "1.5rem" }} /> Clear All Filters
                      </div>

                    )}
                  </div>


                  <div>
                    <Button
                      type="button"
                      style={{
                        backgroundColor: "#FFFFFF",
                        color: "#667085",
                        border: "1px solid #E0E2E7",
                        fontFamily: "Inter",
                        fontWeight: "500",
                        fontSize: "14px",
                        borderRadius: "8px",
                      }}
                      onClick={(e) => {
                        setUserDetails();
                        FilterClick(e);
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        Filter by Status
                        <HiOutlineBars3BottomLeft style={{ color: "#000000", fontSize: "1.3rem" }} />
                      </div>
                      {Object.values(appliedFilters).filter(Boolean).length > 0 && (
                        <span
                          style={{
                            backgroundColor: "#5088FB",
                            color: "#fff",
                            borderRadius: "50%",
                            width: "21px",
                            height: "21px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        >
                          {Object.values(appliedFilters).filter(Boolean).length}
                        </span>
                      )}
                    </Button>
                  </div>


                </div>
              </div>
            </SearchFilterContainer>

            {selectedRows.length > 0 && (
              <SelectedColumnContainer>
                <DeleteButton
                  type="button"
                  className="buttonWidthResponsive"
                  onClick={() => {
                    setDeleteModal(true);
                  }}
                >
                  Delete
                </DeleteButton>
                <div className="column-selected">{selectedRows.length} Selected</div>
                <div
                  className="container-clear-selection"
                  onClick={handleClearSelection}
                >
                  <RxCrossCircled />
                  <span className="column-selected">Clear Response</span>
                </div>
              </SelectedColumnContainer>
            )}

            <TableContainer
              className={classes.tableMainContainer}
            >
              <Table className={classes.table}>
                <TableHead>
                  <TableRow className={classes.tableHeadingRow} >
                    {!(!canDelete && adminData?.userType === "subAdmin") && (
                      <TableCell className={classes.tableHeadingCell}>
                        <div style={{ marginLeft: "1rem", display: "flex", gap: "1rem" }}>
                          <Checkbox
                            style={{ padding: "2px" }}
                            indeterminate={selectedRows.length > 0 && selectedRows.length < tableData.length}
                            // checked={selectedRows.length > 0 && selectedRows.length === tableData.length}
                            checked={tableData.length > 0 && tableData.every((item) => selectedRows.includes(item._id))}
                            onChange={handleSelectAll}
                            color="primary"
                          // disabled={!canDelete && adminData?.userType == "subAdmin"} // Disable if canDelete is false

                          />
                          <div> S.No</div>
                        </div>
                      </TableCell>
                    )}
                    {/* <TableCell className={classes.tableHeadingCell}>
                      S.No
                    </TableCell> */}

                    {filterStatus == 1 && (
                      <>
                        <TableCell className={classes.tableHeadingCell}>
                          User ID
                        </TableCell>
                        <TableCell className={classes.tableHeadingCell}>
                          <div style={{ textAlign: "left", marginLeft: "5rem" }}>
                            Email
                          </div>
                        </TableCell>
                        <TableCell className={classes.tableHeadingCell}>
                          Status Type
                          {/* {" "}
                            <img
                              src={vector}
                              style={{
                                cursor: "pointer",
                                transition: "transform 0.3s ease",
                                transform: `rotate(${rotations.sortByRejectingDate}deg)`,
                              }}
                              onClick={() => toggleSort("sortByRejectingDate")}
                            /> */}
                        </TableCell>
                        <TableCell className={classes.tableHeadingCell}>
                          Joining Date{" "}
                          <img
                            src={vector}
                            style={{
                              cursor: "pointer",
                              transition: "transform 0.3s ease",
                              transform: `rotate(${rotations.sortByJoiningDate}deg)`,
                            }}
                            onClick={() => toggleSort("sortByJoiningDate")}
                          />
                        </TableCell>
                        <TableCell className={classes.tableHeadingCell}>
                          Recent Activity Date & Time{" "}
                          <img
                            src={vector}
                            style={{
                              cursor: "pointer",
                              transition: "transform 0.3s ease",
                              transform: `rotate(${rotations.sortByRecentActivityDate}deg)`,
                            }}
                            onClick={() => toggleSort("sortByRecentActivityDate")}
                          />
                        </TableCell>
                      </>
                    )}
                    {filterStatus == 3 && (
                      <>
                        <TableCell className={classes.tableHeadingCell}>
                          <div style={{
                            textAlign: "left",
                            marginLeft: "1rem"
                          }}>
                            User Name{" "}
                            <img
                              src={vector}
                              style={{
                                cursor: "pointer",
                                transition: "transform 0.3s ease",
                                transform: `rotate(${rotations.sortByUserName}deg)`,
                              }}
                              onClick={() => toggleSort("sortByUserName")}
                            />
                          </div>
                        </TableCell>
                        <TableCell className={classes.tableHeadingCell}>
                          Request Status
                        </TableCell>
                        <TableCell className={classes.tableHeadingCell}>
                          Rejected On{" "}
                          <img
                            src={vector}
                            style={{
                              cursor: "pointer",
                              transition: "transform 0.3s ease",
                              transform: `rotate(${rotations.sortByRejectingDate}deg)`,
                            }}
                            onClick={() => toggleSort("sortByRejectingDate")}
                          />
                        </TableCell>
                        <TableCell className={classes.tableHeadingCell}>
                          <div style={{
                            textAlign: "left",
                            marginLeft: "4rem"

                          }}>
                            Reason
                          </div>
                        </TableCell>
                        <TableCell className={classes.tableHeadingCell}>
                          User ID
                        </TableCell>
                        <TableCell className={classes.tableHeadingCell}>
                          <div style={{
                            textAlign: "left",
                            marginLeft: "2rem"

                          }}>
                            Legal Name
                          </div>
                        </TableCell>
                        <TableCell className={classes.tableHeadingCell}>
                          SSN Number
                        </TableCell>
                      </>
                    )}

                    <TableCell className={classes.tableHeadingCell}>
                      Device Type
                    </TableCell>
                    {filterStatus == 1 && (
                      <TableCell className={classes.tableHeadingCell}>
                        Device ID
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                {isLoading && tableData && tableData.length > 0 ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={13} align="center" style={{ border: "none" }}>
                        <Loading />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : tableData && tableData.length > 0 ? (
                  <>
                    <TableBody>
                      {tableData.map((user, index) => (
                        <TableRow className={classes.tableBodyRow} key={user._id} >
                          {!(!canDelete && adminData?.userType === "subAdmin") && (
                            <TableCell className={classes.textMiddle}>
                              <div style={{ marginLeft: "1rem", display: "flex", gap: "1rem" }}>
                                <Checkbox
                                  style={{ padding: "2px" }}
                                  checked={selectedRows.includes(user._id)}
                                  onChange={() => handleSelectRow(user._id)}
                                  color="primary"
                                  disabled={!canDelete && adminData?.userType == "subAdmin"} // Disable if canDelete is false
                                />
                                <div>{index + 1 + rowsPerPage * (page - 1)}</div>
                              </div>
                            </TableCell>

                          )}
                          {/* <TableCell className={classes.textMiddle}>
                            <div>{index + 1 + rowsPerPage * (page - 1)}</div>
                          </TableCell> */}

                          {filterStatus == 1 && (
                            <>
                              <TableCell className={classes.textMiddle} >
                                <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", justifyContent: "center" }}>
                                  <div style={{ cursor: "pointer", textDecoration: "underline", color: "#375DFB" }}

                                    onClick={() => navigate(`/registrationDetails/${user._id}`,
                                      // { state: { from: "registrationRequest" } }
                                      { state: { from: "registrationRequest", tabStatus: filterStatus, page, rowsPerPage } }
                                    )}
                                  >
                                    {user?.userId || "N/A"}
                                  </div>
                                  <div>
                                    <TiInfoLarge
                                      style={{
                                        backgroundColor: "#5088FB",
                                        color: "#FFFFFF",
                                        fontSize: "0.8rem",
                                        cursor: "pointer",
                                        borderRadius: "1rem",
                                      }}
                                      onClick={(e) => {
                                        setUserDetails(user);
                                        handleFilterClick(e)
                                      }}
                                    />
                                  </div>
                                </div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div
                                  style={{
                                    textAlign: "left",
                                    marginLeft: "5rem"

                                  }}
                                >{(get(user, "email", "---"))}</div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                {!user?.isBankAccountCompleted && user?.isStripeVerified == false && (
                                  <span className="request-profile">
                                    Profile not completed
                                  </span>
                                )}
                                {user?.isBankAccountCompleted && user?.documentStatus == "1" && user?.profileStatus == "1" && user?.isStripeVerified == false && (
                                  <span className="request-stripe">
                                    Waiting for
                                    Stripe Verification
                                  </span>
                                )}
                                {user?.isStripeVerified == true && (
                                  <span className="request">
                                    Waiting for
                                    Admin Verification
                                  </span>
                                )}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div>{extractOnlyDate(get(user, "createdAt", "---"))}</div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div>{extractDate(get(user, "updatedAt", "---"))}</div>
                              </TableCell>
                            </>
                          )}
                          {filterStatus == 3 && (
                            <>
                              <TableCell className={classes.textMiddle}>
                                <div style={{ cursor: "pointer", textDecoration: "underline", color: "#375DFB", textAlign: "left", marginLeft: "1rem" }}
                                  onClick={() => navigate(`/registrationDetails/${user._id}`, {
                                    state: {
                                      from: "registrationRequest", tabStatus: filterStatus, page,
                                      rowsPerPage
                                    }
                                  })}
                                >
                                  {user?.userName || "N/A"}
                                </div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                {user?.isStripeProfileVerified == "3" && (
                                  <div className="request-stripe" >
                                    Rejected by Stripe
                                  </div>
                                )}
                                {user?.isStripeVerified == true && (
                                  <div className="request">
                                    Rejected by Admin
                                  </div>
                                )}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>

                                {user?.isStripeProfileVerified == "3" && (
                                  <div>{extractDate(get(user, "requestRejectOn", "---"))}</div>

                                )}
                                {user?.isStripeVerified == true && (
                                  <div>{extractDate(get(user, "latestViewHistory.createdAt", "---"))}</div>
                                )}
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "5px",
                                  textAlign: "left",
                                  marginLeft: "4rem"
                                }}>
                                  {user?.latestViewHistory?.profileReason && (
                                    <div>
                                      Profile:&nbsp;
                                      <span style={{ color: "red" }}>
                                        {user.latestViewHistory.profileReason}
                                      </span>
                                    </div>
                                  )}

                                  {user?.latestViewHistory?.documentReason && (
                                    <div>
                                      Document:&nbsp;
                                      <span style={{ color: "red" }}>
                                        {user.latestViewHistory.documentReason}
                                      </span>
                                    </div>
                                  )}
                                  {user?.stripeProfileRejectionReason && (
                                    <div>
                                      Stripe:&nbsp;
                                      <span style={{ color: "red" }}>
                                        {user?.stripeProfileRejectionReason?.length > 30 ? (
                                          <>
                                            {expandedRows[user._id]?.stripeProfileRejectionReason
                                              ? user.stripeProfileRejectionReason
                                              : `${user.stripeProfileRejectionReason.substring(0, 30)}... `}
                                            <span
                                              style={{ color: "#375DFB", cursor: "pointer", textDecoration: "underline" }}
                                              onClick={() => toggleExpand(user._id, "stripeProfileRejectionReason")}
                                            >
                                              {expandedRows[user._id]?.stripeProfileRejectionReason ? " Show Less" : " More"}
                                            </span>
                                          </>
                                        ) : (
                                          user?.stripeProfileRejectionReason || "N/A"
                                        )}
                                      </span>
                                    </div>
                                  )}
                                </div>

                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div>{get(user, "stringId", "---")}</div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div style={{ display: "flex", gap: "5px", textAlign: "left", whiteSpace: "nowrap", marginLeft: "2rem" }}>{user?.fullName || "N/A"}
                                  <div>
                                    <TiInfoLarge
                                      style={{
                                        backgroundColor: "#5088FB",
                                        color: "#FFFFFF",
                                        fontSize: "0.8rem",
                                        cursor: "pointer",
                                        borderRadius: "1rem",
                                      }}
                                      onClick={(e) => {
                                        setUserDetails(user);
                                        handleFilterClick(e)
                                      }}
                                    />
                                  </div>
                                </div>
                              </TableCell>
                              <TableCell className={classes.textMiddle}>
                                <div>
                                  {get(user, "ssnlast4")
                                    ? `XXXXXX${get(user, "ssnlast4").slice(-4)}`
                                    : "N/A"}
                                </div>
                              </TableCell>


                            </>
                          )}
                          <TableCell className={classes.textMiddle}>
                            {/* {get(user, "sessionData.deviceType") == "android" ? (
                              <img src={android} style={{ width: "24px", height: "24px" }} />
                            ) : get(user, "sessionData.deviceType") == "ios" ? (
                              <GrApple style={{ fontSize: "20px", color: "#424245" }} />
                            ) : (
                              "Logged Out"
                            )} */}
                            {get(user, "sessionData.logOut") === true ? (
                              <span>Logged Out</span>
                            ) : get(user, "sessionData.deviceType") === "android" ? (
                              <img src={android} style={{ width: "24px", height: "24px" }} />
                            ) : get(user, "sessionData.deviceType")?.toLowerCase() === "ios" ? (
                              <GrApple style={{ fontSize: "20px", color: "#424245" }} />
                            ) : (
                              <span>Logged Out</span>
                            )}
                          </TableCell>
                          {filterStatus == 1 && (
                            <TableCell className={classes.textMiddle}>
                              <div>{get(user, "sessionData.deviceName", "N/A")}</div>
                            </TableCell>
                          )}

                        </TableRow>
                      ))}
                    </TableBody>
                  </>
                ) : (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={13} align="center" style={{ padding: "2rem", border: "none" }}>
                          <DashHeading style={{ textAlign: "center", padding: "2rem", color: "#0000000" }}><NoResults /></DashHeading>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                )}
              </Table>
            </TableContainer>
            {(tableData && tableData.length > 0) && (
              <>
                <Stack spacing={2} className={classes.paginationContainer}>
                  <Pagination
                    count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                    page={page}
                    onChange={(event, value) => handleChangePage(event, value)} // Update page
                    renderItem={(item) => (
                      <PaginationItem
                        slots={{ previous: HiMiniArrowLeft, next: HiMiniArrowRight }}
                        {...item}
                      />
                    )}
                  />
                </Stack>
              </>
            )}
          </ProfileDetailForm>
        </DashboardWrapper>
      </DashboardContainer>

      {/* Modal for Delete User  */}
      <Modal
        maxWidth="lg"
        width="360px"
        RoundedCorners={true}
        isOpen={deleteModal}
        onClose={() => {
          setDeleteModal(false);
        }}
        backgroundModal={false}
        backgroundModalContent={false}
        title={
          <div>
            <div className="d-flex align-items-center justify-content-end">
              <RxCross2
                style={{
                  cursor: "pointer",
                }}
                onClick={() => { setDeleteModal(false); }}
              />
            </div>
            <p className="profile-section-text">Delete Users</p>
            <div className="logout-header" style={{ paddingTop: "0px" }}>Are you sure you want to delete users? Deleting them will permanently remove all their data.</div>
          </div>
        }
        content={
          <>
            <div className="logout-button-group">
              <div
                className="cancel-button"
                onClick={() => {
                  setDeleteModal(false);
                }}
              >
                Cancel
              </div>
              <div className="logout-button" style={{ background: "#5088FB" }} onClick={() => DeleteUser(null)}>
                Confirm
              </div>
            </div>
          </>
        }
      />

      {/* Popover for user info */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 1.5, width: "250px" }}>
          <div>
            <div className="user_info">User Info</div>
            <div style={{ display: "flex", flexDirection: "column", gap: "4px", marginTop: "10px" }}>
              {filterStatus == 1 && (
                <>
                  <div style={{ display: "flex", gap: "8px", fontSize: "13px" }}>
                    <div>
                      <div>User Name</div>
                      <div>Legal Name</div>
                      <div>Referral Code </div>
                      <div>Mobile Number </div>
                      <div>Date of Birth </div>
                    </div>
                    <div>
                      <div>:</div>
                      <div>:</div>
                      <div>:</div>
                      <div>:</div>
                      <div>:</div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                      <div>{userDetails?.userName}</div>
                      <div>{userDetails?.fullName}</div>
                      <div>{userDetails?.referralCode}</div>
                      <div>{userDetails?.countryCode} {userDetails?.phoneNumber}</div>
                      <div>{extractOnlyDate(userDetails?.dateOfBirth)}</div>
                    </div>
                  </div>
                </>
              )}
              {filterStatus == 3 && (
                <>
                  <div className="userdata"><LuContact className="user_icon" /><span>{userDetails?.userId}</span></div>
                  <div className="userdata"><AiOutlineMail className="user_icon" /><span>{userDetails?.email} <img src={Verified} /> </span> </div>
                  <div className="userdata"><IoCallOutline className="user_icon" /><span>{userDetails?.countryCode} {userDetails?.phoneNumber} <img src={Verified} /> </span></div>
                  <div className="userdata"><GoCalendar className="user_icon" /><span>{extractOnlyDate(userDetails?.dateOfBirth)}</span></div>
                </>
              )}
            </div>
          </div>
        </Box>
      </Popover>


      {/* /popup filter */}
      <Popover
        id={ids}
        open={openFilter}
        anchorEl={anchorElFilter}
        onClose={handleCloseFilter}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{ sx: { p: 2, width: 270 } }}
      >
        <div style={{ fontSize: "18px", fontWeight: "700", fontFamily: "Roboto" }} >
          Filter by Status
        </div>


        <FormControl component="fieldset" variant="standard">
          <FormGroup>
            {filterStatus == 1 && (
              <>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tempValues.stripe}
                      onChange={handleChange}
                      name="stripe"
                      size="small"
                      style={{ color: "#5088FB" }}
                    />
                  }
                  label="Waiting for Stripe Verification"
                  sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
                />
                <hr style={{ margin: "0px" }} />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tempValues.admin}
                      onChange={handleChange}
                      name="admin"
                      size="small"
                      style={{ color: "#5088FB", }}
                    />
                  }
                  label="Waiting for Admin Verification"
                  sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
                />
                <hr style={{ margin: "0px" }} />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tempValues.incomplete}
                      onChange={handleChange}
                      name="incomplete"
                      size="small"
                      style={{ color: "#5088FB" }}
                    />
                  }
                  label="Profile not Completed"
                  sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
                />
              </>
            )}

            {filterStatus == 3 && (
              <>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tempValues.rejectedStripe}
                      onChange={handleChange}
                      name="rejectedStripe"
                      size="small"
                      style={{ color: "#5088FB" }}
                    />
                  }
                  label="Rejected by Stripe"
                  sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
                />
                <hr style={{ margin: "0px" }} />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tempValues.rejectedAdmin}
                      onChange={handleChange}
                      name="rejectedAdmin"
                      size="small"
                      style={{ color: "#5088FB" }}
                    />
                  }
                  label="Rejected by Admin"
                  sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }}
                />
              </>
            )}
          </FormGroup>
        </FormControl>



        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, marginTop: "8px" }}>
          <Button
            style={{ fontSize: "14px", width: "6rem" }}
            onClick={handleCancel}

          >Cancel
          </Button>
          <Button variant="contained" onClick={handleApplyFilter} style={{ backgroundColor: "#5088FB", color: "#FFFFFF", fontSize: "14px" }}>
            Apply Filter
          </Button>
        </Box>
      </Popover>


      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistrationRequest);




